/*
* FormBuilder is a reusable Module to generate form dynamically
* Tutorial to know how to build a form : http://projets2.afidium.com/projects/wui/wiki/FormBuilder
*/

// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// PrimeNg
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';

import { GenericModule } from '../generic.module';

// Own Components
import { fieldComponents, fieldsModules } from './fields/index';
import { fieldsetComponents, fieldsetModules } from './fieldsets/index';
import { formComponents, formModules } from './forms/index';

// Services
import { FormBuilderService } from '../../service/formBuilder/formBuilder.service';
import { DatePipeModule } from '../../date/date.module';
import { SegmentModule } from './fieldsets/segment-fieldset/segment.fieldset.module';
import { PipesModule } from '../../pipes/pipes.module';
import { DateParserModule } from '../../service/date/dateParser.module';
import { TravellerFormModule } from './forms/travellerForm/travellerForm.module';
import { CalendarModule as AfiCalendarModule } from './fields/calendar/calendar.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CalendarModule,
        DropdownModule,
        MultiSelectModule,
        AutoCompleteModule,
        GenericModule,
        DatePipeModule,
        SegmentModule,
        AfiCalendarModule,
        PipesModule,
        DateParserModule,
        TravellerFormModule,
        ...formModules,
        ...fieldsModules,
        ...fieldsetModules
    ],
    declarations: [
        ...fieldComponents,
        ...fieldsetComponents,
        ...formComponents
    ],
    exports: [
        ...fieldComponents,
        ...fieldsetComponents,
        ...formComponents
    ],
    providers: [
        FormBuilderService
    ]
})
export class FormBuilderModule { }
